module.exports = __webpack_public_path__ + "img/webpay.28d72c63.svg";